import StepContent from '@mui/material/StepContent';
import Stepper from '@mui/material/Stepper';
import { Fragment } from 'react/jsx-runtime';
import { useStoreSelector } from 'v3/data/store';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { IVerticalStepperProps } from './interfaces';
import { AlignColumn, AlignRow, StepLabelStyled, StepStyled, SubLabelStyle, SubtitleLargeCustom } from './styles';

export const VerticalStepper = ({ steps, currentStep }: IVerticalStepperProps) => {
  const { flagSelectForPreContract } = useStoreSelector((store) => store.token);
  const activeStepTest = {
    [ContractNavigationEnum.INITIAL]: 0,
    [ContractNavigationEnum.TOKEN_REQUESTED]: 0,
    [ContractNavigationEnum.TOKEN_VERIFIED]: 0,
    [ContractNavigationEnum.PRE_CONTRACT]: flagSelectForPreContract ? 1 : 0,
    [ContractNavigationEnum.DEVICE_DETAILS]: flagSelectForPreContract ? 2 : 1,
    [ContractNavigationEnum.SIGN_CONTRACT]: flagSelectForPreContract ? 3 : 2,
    [ContractNavigationEnum.CONTRACT_COMPLETED]: flagSelectForPreContract ? 3 : 2,
  };
  const stepsTest = steps.map(
    ({ step, isCompleted, subLabel, label, stepState, stayOpenAfterCompletion }, index: number) => {
      const isActiveStep =
        stepState.includes(currentStep) || (stayOpenAfterCompletion && activeStepTest[currentStep] > 0);

      return (
        <StepStyled completed={isCompleted} key={index} active={isActiveStep}>
          <AlignColumn>
            <AlignRow>
              <StepLabelStyled>
                <SubtitleLargeCustom>{label}</SubtitleLargeCustom>
              </StepLabelStyled>
            </AlignRow>
            <SubLabelStyle>
              <BodySmallRegular>{subLabel}</BodySmallRegular>
            </SubLabelStyle>
          </AlignColumn>

          <StepContent>{step}</StepContent>
        </StepStyled>
      );
    },
  );

  return (
    <Stepper orientation="vertical" connector={<Fragment />} activeStep={activeStepTest[currentStep]}>
      {stepsTest}
    </Stepper>
  );
};
